module.exports = __webpack_public_path__ + "img/pitches_active.55b92e0e.svg";